import React, { useContext } from 'react'
import { FaFacebookF, FaLinkedinIn, FaStar } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import Link from 'next/link';
import Image from 'next/image'
import { s3Static } from '../../utils/constants';
import { useRouter } from 'next/router'
import { LocationContext } from '../../context/LocationContext';
import { getArticleDateTime } from '../../utils/article-date-time';
import { StringssgMap } from './commons/StringssgMap';
import { googleRating, googleReviewCount, gbpUrl } from '../../utils/business-info';
import { COUNTRY_SWITCHER, aboutPath, getMarket, getMarketFromPath, getNavHubLinks, marketBlogsPath } from '../../utils/markets';

const SG_SERVICE_LINKS = [
    { href: "/sg/personal-trainer", label: "Personal Trainer Singapore" },
    { href: "/sg/aircon-servicing-singapore", label: "Aircon Servicing Singapore" },
    { href: "/sg/part-time-cleaner-singapore", label: "Part Time Helper" },
    { href: "/sg/handyman-singapore-services", label: "Handyman Services" },
    { href: "/sg/plumber-singapore-services", label: "Plumber Service" },
    { href: "/sg/electrician-services-singapore", label: "Electrician Service" },
    // { href: "/sg/handyman-singapore-services/handyman-price-list", label: "Handyman Price List" },
    // { href: "/sg/electrician-services-singapore/electrician-price-singapore", label: "Electrician Price List" },
    // { href: "/sg/property-agent", label: "Property Agent" },
    // { href: "/sg/financial-adviser-singapore", label: "Financial Advisor" },
]

export const Footer = () => {
    const router = useRouter()
    const { modifiedDate, month, year } = getArticleDateTime();

    const { countryCd: contextCountryCd } = useContext(LocationContext)

    // UAE / Malaysia pages: the route decides the market (see IndexNav). Their
    // footer lists their own hubs and drops the Singapore map, address and
    // Google rating - those describe the Singapore business, not a local one.
    const routeMarket = getMarketFromPath(router.pathname)
    const countryCd = routeMarket ? routeMarket.countryCd : contextCountryCd
    const marketHubLinks = getNavHubLinks(countryCd)
    const isExpansionMarket = !!marketHubLinks
    // Resolved from countryCd, not routeMarket: on routes without a country
    // prefix (/signin, /contact) the market comes from LocationContext, and
    // routeMarket is null there.
    const market = getMarket(countryCd)

    return (
        <footer id="footer" className="relative overflow-hidden"> 
            {/* Upper Section - Links */}
            <div className='bg-linear-to-br from-slate-900 via-slate-800 to-slate-900 py-12 md:py-16 px-5'> 
                <div className='container max-w-6xl mx-auto'>
                    <div className='grid gap-10 md:gap-16'>
                        {/* StringsSG Links */}
                        <div className='space-y-6'>
                            <h2 className='text-center'>
                                <span className='text-xl font-bold text-white tracking-wide'>
                                    Strings<span className="text-orange-400">SG</span>
                                </span>
                            </h2>
                            <div className='flex justify-center'>
                                <ul className='grid grid-cols-2 md:flex gap-x-20 gap-y-3 md:gap-10'>
                                    <li>
                                        <Link href={aboutPath(countryCd)} prefetch={false} className="text-slate-400 hover:text-white transition-colors duration-200 text-sm flex items-center gap-2 group">
                                            <span className="w-1.5 h-1.5 rounded-full bg-slate-600 group-hover:bg-orange-400 transition-colors"></span>
                                            About
                                        </Link>
                                    </li>
                                    <li>
                                        <Link href="/faq" prefetch={false} className="text-slate-400 hover:text-white transition-colors duration-200 text-sm flex items-center gap-2 group">
                                            <span className="w-1.5 h-1.5 rounded-full bg-slate-600 group-hover:bg-orange-400 transition-colors"></span>
                                            FAQ
                                        </Link>
                                    </li>
                                    <li>
                                        <Link href="/privacy-policy" prefetch={false} className="text-slate-400 hover:text-white transition-colors duration-200 text-sm flex items-center gap-2 group">
                                            <span className="w-1.5 h-1.5 rounded-full bg-slate-600 group-hover:bg-orange-400 transition-colors"></span>
                                            Privacy
                                        </Link>
                                    </li>
                                    <li>
                                        <Link href="/terms" prefetch={false} className="text-slate-400 hover:text-white transition-colors duration-200 text-sm flex items-center gap-2 group">
                                            <span className="w-1.5 h-1.5 rounded-full bg-slate-600 group-hover:bg-orange-400 transition-colors"></span>
                                            Terms
                                        </Link>
                                    </li>
                                    <li>
                                        <Link href="/contact" prefetch={false} className="text-slate-400 hover:text-white transition-colors duration-200 text-sm flex items-center gap-2 group">
                                            <span className="w-1.5 h-1.5 rounded-full bg-slate-600 group-hover:bg-orange-400 transition-colors"></span>
                                            Contact
                                        </Link>
                                    </li>
                                    {/* UAE / Malaysia: one listing per country covers both services. */}
                                    {isExpansionMarket && <li>
                                        <Link href={marketBlogsPath(countryCd)} prefetch={false} className="text-slate-400 hover:text-white transition-colors duration-200 text-sm flex items-center gap-2 group">
                                            <span className="w-1.5 h-1.5 rounded-full bg-slate-600 group-hover:bg-orange-400 transition-colors"></span>
                                            Blogs
                                        </Link>
                                    </li>}
                                    {!isExpansionMarket && <li>
                                        {router.pathname.includes("personal-trainer") && (
                                        <Link href={`/${countryCd}/blogs/health-fitness`} prefetch={false} className="text-slate-400 hover:text-white transition-colors duration-200 text-sm flex items-center gap-2 group">
                                            <span className="w-1.5 h-1.5 rounded-full bg-slate-600 group-hover:bg-orange-400 transition-colors"></span>
                                            Blogs
                                        </Link>
                                        )}
                                        {router.pathname.includes("aircon-servicing-singapore") && (
                                        <Link href={`/${countryCd}/blogs/hvac-services`} prefetch={false} className="text-slate-400 hover:text-white transition-colors duration-200 text-sm flex items-center gap-2 group">
                                            <span className="w-1.5 h-1.5 rounded-full bg-slate-600 group-hover:bg-orange-400 transition-colors"></span>
                                            Blogs
                                        </Link>
                                        )}
                                        {router.pathname.includes("part-time-cleaner-singapore") && (
                                        <Link href={`/${countryCd}/blogs/house-keeping`} prefetch={false} className="text-slate-400 hover:text-white transition-colors duration-200 text-sm flex items-center gap-2 group">
                                            <span className="w-1.5 h-1.5 rounded-full bg-slate-600 group-hover:bg-orange-400 transition-colors"></span>
                                            Blogs
                                        </Link>
                                        )}
                                        {
                                        (!router.pathname.includes("personal-trainer") &&
                                            !router.pathname.includes("aircon-servicing-singapore") &&
                                            !router.pathname.includes("part-time-cleaner-singapore")) && (
                                            <Link href={`/${countryCd}/blogs`} prefetch={false} className="text-slate-400 hover:text-white transition-colors duration-200 text-sm flex items-center gap-2 group">
                                                <span className="w-1.5 h-1.5 rounded-full bg-slate-600 group-hover:bg-orange-400 transition-colors"></span>
                                                Blogs
                                            </Link>
                                        )
                                        }
                                    </li>}
                                    <li>
                                        <Link href="/sitemap.xml" prefetch={false} className="text-slate-400 hover:text-white transition-colors duration-200 text-sm flex items-center gap-2 group">
                                            <span className="w-1.5 h-1.5 rounded-full bg-slate-600 group-hover:bg-orange-400 transition-colors"></span>
                                            Sitemap
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        {/* Services Links */}
                        <div className='space-y-6'>
                            <h2 className='text-center'>
                                <span className='text-xl font-bold text-white tracking-wide'>
                                    Services
                                </span>
                            </h2>
                            <div className='flex justify-center'>
                                <ul className='grid md:grid-cols-2 gap-x-12 gap-y-3'>
                                    {(marketHubLinks ?? SG_SERVICE_LINKS).map((item, i) => (
                                        <li key={i}>
                                            <Link href={item.href} prefetch={false} className="text-slate-400 hover:text-white transition-colors duration-200 text-sm flex items-center gap-2 group">
                                                <span className="w-1.5 h-1.5 rounded-full bg-slate-600 group-hover:bg-orange-400 transition-colors"></span>
                                                {item.label}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Lower Section - Company Info */}
            <div className='bg-slate-900 pt-8 pb-6 px-5'>
                <div className='max-w-5xl mx-auto'>
                    <div className='grid grid-cols-1 lg:grid-cols-2 gap-10 items-center'>
                        {/* Map */}
                        {isExpansionMarket ? (
                            <div className='max-w-md mx-auto text-center lg:text-left space-y-2'>
                                <p className='text-slate-300 text-sm leading-relaxed'>
                                    Serving {market.cities.map((c) => c.name).join(' and ')}
                                </p>
                                {!market.paymentsEnabled &&
                                <p className='text-slate-500 text-sm'>
                                    Book online and confirm in the StringsSG app.
                                </p>
                                }
                            </div>
                        ) : (
                        <div className='overflow-hidden'>
                            <StringssgMap/>                            

                            {/* Address */}
                            <div className='max-w-md mx-auto m-2 bg-slate-800/50 backdrop-blur-sm rounded-b-xl p-4 border border-slate-700/50'>
                                <p className='text-slate-300 text-sm leading-relaxed'>
                                    📍 Paya Lebar Square,<br/>
                                    60 Paya Lebar Rd,<br/>
                                    Singapore 409051
                                </p>
                            </div>
                        </div>
                        )}

                        {/* Company Details */}
                        <div className='space-y-6 text-center lg:text-left'>
                            {/* Company Name & UEN */}
                            <div className='space-y-2'>
                                <h2 className='text-2xl font-bold text-white'>
                                    StringsSG Pte Ltd
                                </h2>
                                <p className='text-slate-500 text-sm'>
                                    Co Registration UEN: 201813375G
                                </p>
                            </div>

                            {/* Rating */}
                            {!isExpansionMarket &&
                            <div className='flex items-center justify-center lg:justify-start gap-3'>
                                <div className='bg-linear-to-r from-green-500 to-emerald-600 text-white text-sm font-bold px-3 py-1.5 rounded-full shadow-lg'>
                                    {googleRating}
                                </div>
                                <div className="flex gap-1">
                                    {[...new Array(5)].map((item, x) =>            
                                        <FaStar key={x} className='text-amber-400 text-lg drop-shadow-sm'/>                    
                                    )}
                                </div>
                                <a href={gbpUrl} target="_blank" rel="noreferrer" className='text-slate-400 hover:text-white text-sm transition-colors'>
                                    {googleReviewCount} Google reviews
                                </a>
                            </div>
                            }

                            {/* App Install */}
                            <div className='space-y-3'>
                                <p className='text-slate-400 text-sm font-medium'>Download the mobile app</p>
                                <div className="flex items-center justify-center lg:justify-start gap-3">
                                    <Link href="https://play.google.com/store/apps/details?id=com.stringssg.app" className="p-2" target="_blank">
                                        <Image  height={40} width={130} src={s3Static + "google-play-badge.png"} alt="StringsSG google play"/>
                                    </Link>                                    
                                    <Link href="https://itunes.apple.com/us/app/stringssg/id1347513244" className="p-2" target="_blank">
                                            <Image className='bg-white rounded-lg' height={39} width={130} src={s3Static + "apple-store-badge.png"} alt="StringsSG apple store"/>
                                    </Link>
                                </div> 
                            </div>

                            {/* Countries - also the site-wide crawl path into /ae and /my */}
                            <nav aria-label="StringsSG countries">
                                <ul className='flex flex-wrap justify-center lg:justify-start gap-x-4 gap-y-1 text-sm'>
                                    {COUNTRY_SWITCHER.map((country) => (
                                        <li key={country.countryCd}>
                                            <Link href={country.href} prefetch={false} className='text-slate-500 hover:text-white transition-colors'>
                                                {country.label}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </nav>

                            {/* Social Links */}
                            <div className="flex justify-center lg:justify-start gap-4">
                                <a 
                                    href="https://www.facebook.com/StringsSG/" 
                                    target="_blank" 
                                    rel="noreferrer" 
                                    className="w-11 h-11 bg-slate-800 hover:bg-blue-600 rounded-xl flex items-center justify-center text-slate-400 hover:text-white transition-all duration-300 hover:scale-110 hover:shadow-lg hover:shadow-blue-500/25" 
                                    aria-label="Visit StringsSG Facebook page"
                                >
                                    <FaFacebookF className="text-lg" />
                                </a>
                                <a 
                                    href="https://www.linkedin.com/company/stringssg/" 
                                    target="_blank" 
                                    rel="noreferrer" 
                                    className="w-11 h-11 bg-slate-800 hover:bg-blue-700 rounded-xl flex items-center justify-center text-slate-400 hover:text-white transition-all duration-300 hover:scale-110 hover:shadow-lg hover:shadow-blue-600/25" 
                                    aria-label="Visit StringsSG LinkedIn page"
                                >
                                    <FaLinkedinIn className="text-lg" />
                                </a>
                                <a 
                                    href="https://x.com/stringssg" 
                                    target="_blank" 
                                    rel="noreferrer" 
                                    className="w-11 h-11 bg-slate-800 hover:bg-slate-700 rounded-xl flex items-center justify-center text-slate-400 hover:text-white transition-all duration-300 hover:scale-110 hover:shadow-lg hover:shadow-slate-500/25" 
                                    aria-label="Visit StringsSG Twitter page"
                                >
                                    <FaXTwitter className="text-lg" />
                                </a>
                            </div>       
                        </div> 
                    </div>
                </div>

                {/* Copyright */}
                <div className='text-center pt-10 pb-16'>
                    <div className="w-24 h-px bg-linear-to-r from-transparent via-slate-700 to-transparent mx-auto mb-6"></div>
                    <p className="text-slate-500 text-sm">
                        Copyright &copy; StringsSG {year}
                    </p>
                </div>
            </div>
        </footer>
    )
}
